import { ValidateCheckbox } from "@/Checkbox";
import DateButton from "@/common/DateButton";
import { ValidateServiceCard } from "@/common/ServiceCard";
import { Divider } from "@/Divider";
import MessageModal from "@/MessageModal";
import { ValidateSelectBoxImg } from "@/SelectBoxImg";
import ToggleSwitch from "@/ToggleSwitch";
import { useEffect, useState, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import useOpenModal from "^/common/useOpenModal";
import { CalendarNew as CalendarComponent } from "@/CalendarNew";
// import { Button } from "@/Button";
import { formatDate, addDays } from "%/date";
import { PetDataType } from "~/types/common";
import {
  useReserveForms,
  useCalculateCoin,
  // useCreateReserve,
  useUpdateTempReserve,
  // useCreateReserve,
} from "~/services/reservation";
import { useReservationDisabledDates } from "^/reservation/useReservationDisabledDates";
// import { useTossPreOrder } from "~/services/payment/toss";
import { loadTossPayments } from "@tosspayments/tosspayments-sdk";

import { ValidateControllerSelect } from "@/ControllerSelect";
import { Dialog } from "@/Dialog";
import ContractModal from "@/common/ContractModal";
import { useEnsureContractRequest } from "~/services/customer/contractRequest";
import { useRouter } from "@tanstack/react-router";

interface ReservationClassState {
  storeName: string;
  storeType: string;
  content: string;
  weekly: boolean;
  day: string;
  services: string;
  animal: string;
  agree: boolean;
  startDate: Date | null;
  endDate: Date | null;
  [key: string]: any; // 인덱스 시그니처 추가
}

const ReservationClass = ({
  storeName,
  storeType,
  storeData,
  petList,
  date,
}: {
  storeName: string;
  storeType: string;
  storeData: { value: string; label: string };
  petList: PetDataType[];
  date: string;
}) => {
  const { history } = useRouter();
  const {
    // handleSubmit,
    control,
    formState: { errors, isValid },
    watch,
    setValue,
  } = useForm<ReservationClassState>({
    defaultValues: {
      storeName: storeName,
      storeType: storeType,
      content: "",
      weekly: false,
      day: "",
      services: "",
      animal: "",
      agree: false,
      startDate: null,
      endDate: null,
    },
    mode: "onChange",
  });
  // const [ setDate] = useState(getToday());
  const { isOpenModal, clickModal, closeModal } = useOpenModal();
  const [isStart, setIsStart] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [showContractDialog, setShowContractDialog] = useState(false);
  const [showContractModal, setShowContractModal] = useState(false);
  // 예약 게이트: ensure(find-or-autosend)로 확보한 서명 대상 requestSeq
  const [ensuredRequestSeq, setEnsuredRequestSeq] = useState<number | null>(
    null,
  );
  const ensureContractMutation = useEnsureContractRequest();
  const [showCoinShortageDialog, setShowCoinShortageDialog] = useState(false);
  const [showReservationCompleteDialog, setShowReservationCompleteDialog] =
    useState(false);
  const [showPaymentScreen, setShowPaymentScreen] = useState(false);
  const [reservationSeq] = useState<number | null>(null);
  const [paymentOrderData] = useState<any>(null);
  const [contractMessage] = useState("");

  // 토스페이먼츠 관련 refs
  const tossPaymentsRef = useRef<any>(null);
  const widgetsRef = useRef<any>(null);
  const paymentMethodWidgetRef = useRef<any>(null);
  const agreementWidgetRef = useRef<any>(null);
  // const { usePetList,  } = usePet();
  // const { data: petList } = usePetList();

  // 예약 폼 API 연동: companySeq, cdProductType은 실제 상황에 맞게 수정 필요
  const [selectedPetSeq, setSelectedPetSeq] = useState<string | null>(
    petList && petList.length > 0 ? petList[0].petSeq.toString() : null,
  );
  const [showGradeConfirmDialog, setShowGradeConfirmDialog] = useState(false);
  // const [gradeConfirm, setGradeConfirm] = useState(false); // 테스트를 위해 false로 설정

  // petList가 로드되면 첫 번째 반려동물을 자동으로 선택하고 폼 값도 설정
  useEffect(() => {
    if (petList && petList.length > 0) {
      const firstPetSeq = petList[0].petSeq.toString();
      setSelectedPetSeq(firstPetSeq);
      setValue("animal", firstPetSeq, { shouldValidate: true });
    }
  }, [petList, setValue]);

  // 토스페이먼츠 초기화
  // 토스페이먼츠 SDK 초기화 및 위젯 렌더링 (통합)
  useEffect(() => {
    if (!showPaymentScreen || !paymentOrderData) return;

    let isMounted = true;
    console.log("🚀 결제 팝업 열림 - 통합 초기화 시작");

    const initializeAndRenderWidgets = async () => {
      try {
        // 1단계: 토스페이먼츠 SDK 초기화
        console.log("1️⃣ 토스페이먼츠 SDK 초기화 시작");
        const clientKey = paymentOrderData.widgetClientKey;
        const redirectUrl =
          import.meta.env.VITE_TOSS_REDIRECT_URL ||
          "https://app.mungtoday.com/api/payment/toss/brandpay/auth";

        const toss = await loadTossPayments(clientKey, redirectUrl);
        if (!isMounted) return;

        tossPaymentsRef.current = toss;
        console.log("✅ 1단계: 토스페이먼츠 SDK 초기화 완료");

        // 2단계: DOM 요소가 준비될 때까지 대기
        console.log("2️⃣ DOM 요소 대기 시작");
        await new Promise((resolve) => setTimeout(resolve, 300)); // 팝업 렌더링 대기

        const waitForElement = (id: string, maxAttempts = 30) => {
          return new Promise<HTMLElement>((resolve, reject) => {
            let attempts = 0;
            const checkElement = () => {
              const element = document.getElementById(id);
              if (element) {
                console.log(`✅ DOM 요소 ${id} 찾음`);
                resolve(element);
              } else if (attempts < maxAttempts) {
                attempts++;
                setTimeout(checkElement, 100);
              } else {
                reject(
                  new Error(
                    `❌ Element with id "${id}" not found after ${maxAttempts} attempts`,
                  ),
                );
              }
            };
            checkElement();
          });
        };

        await waitForElement("payment-methods");
        await waitForElement("agreement");
        console.log("✅ 2단계: DOM 요소 준비 완료");

        // 3단계: 기존 위젯 정리
        console.log("3️⃣ 기존 위젯 정리");
        if (paymentMethodWidgetRef.current) {
          await paymentMethodWidgetRef.current.destroy();
          paymentMethodWidgetRef.current = null;
        }
        if (agreementWidgetRef.current) {
          await agreementWidgetRef.current.destroy();
          agreementWidgetRef.current = null;
        }

        // 4단계: 위젯 인스턴스 생성
        console.log("4️⃣ 위젯 인스턴스 생성");
        widgetsRef.current = tossPaymentsRef.current.widgets({
          customerKey: paymentOrderData.customerKey,
          brandpay: {
            redirectUrl: redirectUrl,
          },
        });

        // 5단계: 결제 금액 설정
        console.log("5️⃣ 결제 금액 설정", paymentOrderData.payAmount);
        await widgetsRef.current.setAmount({
          value: paymentOrderData.payAmount,
          currency: "KRW",
        });

        // 6단계: 결제 수단 위젯 렌더링
        console.log("6️⃣ 결제 수단 위젯 렌더링");
        const paymentMethodWidget =
          await widgetsRef.current.renderPaymentMethods({
            selector: "#payment-methods",
            variantKey: "DEFAULT",
          });

        // 7단계: 약관 위젯 렌더링
        console.log("7️⃣ 약관 위젯 렌더링");
        const agreementWidget = await widgetsRef.current.renderAgreement({
          selector: "#agreement",
        });

        // 8단계: 위젯 인스턴스 저장 및 이벤트 설정
        console.log("8️⃣ 위젯 인스턴스 저장 및 이벤트 설정");
        paymentMethodWidgetRef.current = paymentMethodWidget;
        agreementWidgetRef.current = agreementWidget;

        paymentMethodWidget.on(
          "paymentMethodSelect",
          (selectedPaymentMethod: any) => {
            console.log("선택된 결제수단:", selectedPaymentMethod);
          },
        );

        console.log("🎉 모든 단계 완료 - 결제 위젯 렌더링 성공");
      } catch (error) {
        console.error("💥 결제 위젯 초기화/렌더링 실패:", error);
        alert(
          "결제 위젯을 불러오는데 실패했습니다. 새로고침 버튼을 클릭해주세요.",
        );
      }
    };

    // 팝업이 열린 후 실행
    const timeoutId = setTimeout(() => {
      initializeAndRenderWidgets();
    }, 100);

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, [showPaymentScreen, paymentOrderData]);

  useEffect(() => {
    if (date) {
      setValue("startDate", new Date(date), { shouldValidate: true });
      setStartDate(new Date(date));
    }
  }, [date]);

  // weekly 상태 감시
  const weeklyValue = watch("weekly");

  // weekly가 false로 변경될 때 endDate와 day 초기화
  useEffect(() => {
    if (!weeklyValue) {
      setValue("endDate", null, { shouldValidate: true });
      setValue("day", "", { shouldValidate: true });
    }
  }, [weeklyValue, setValue]);
  // const companySeq = 1; // 예시값, 실제로는 props 등에서 받아야 함
  const cdProductType = "PRODUCT_TYPE_KINDERGARTEN";
  const { data: reserveForms } = useReserveForms(
    parseInt(storeData.value),
    selectedPetSeq ? Number(selectedPetSeq) : 0,
    cdProductType,
    !!selectedPetSeq,
  );

  // 예약 불가 날짜(정기휴무 + 임시휴무) → 캘린더 비활성화
  const { disabledDates, handleMonthNavigate } = useReservationDisabledDates(
    parseInt(storeData.value),
    cdProductType,
  );

  // 코인 계산 API 훅
  const { mutate: calculateCoin, data: calculateCoinData } = useCalculateCoin();

  // 예약 생성 API 훅 (현재 주석 처리됨)
  // const { mutate: createReserve } = useCreateReserve();

  // 임시 예약 업데이트 API 훅
  const { mutate: updateTempReserve } = useUpdateTempReserve();

  // 토스페이먼츠 API 훅
  // const { mutate: createTossPreOrder, isPending: isCreatingPreOrder } =
  //   useTossPreOrder();
  // const { mutate: confirmTossOrder, isPending: isConfirmingOrder } = useTossOrderConfirm();

  // 코인 잔액 확인 API 훅
  // const totalCoin = calculateCoinData?.data?.paymentCoinTotal || 0;
  // const { data: hasBalanceCoinData, isLoading: isCheckingBalance } =
  //   useHasBalanceCoin(totalCoin);

  // 폼 값들을 watch로 감지
  const watchedValues = watch();

  // 디버깅을 위한 로그
  console.log("=== 폼 상태 디버깅 ===");
  console.log("agree value:", watchedValues.agree);
  console.log("agree error:", errors.agree);
  console.log("startDate value:", watchedValues.startDate);
  console.log("endDate value:", watchedValues.endDate);
  console.log("animal value:", watchedValues.animal);
  console.log("isValid:", isValid);
  console.log("전체 errors:", errors);
  console.log("전체 watchedValues:", watchedValues);
  console.log("=== 디버깅 끝 ===");

  // 코인 계산 API 호출 함수
  const callCalculateCoin = () => {
    if (!reserveForms || !selectedPetSeq) return;
    console.log(reserveForms);
    // 선택된 반려동물 찾기
    const selectedPet = petList?.find(
      (pet: PetDataType) => pet.petSeq.toString() === selectedPetSeq,
    );
    if (!selectedPet) return;

    // 요청 데이터 구성
    const requestData = {
      reservationSeq: null,
      cdProductType: cdProductType,
      gradeConfirm: reserveForms.gradeConfirm,
      paymentCoinTotal: null,
      companySeq: parseInt(storeData.value),
      reserveForm: {
        productSeq: reserveForms.reserveForm.productSeq, // 기본값 설정
        dtReservStart: watchedValues.startDate
          ? formatDate(watchedValues.startDate)
          : null,
        dtReservEnd: watchedValues.endDate
          ? formatDate(watchedValues.endDate)
          : null,
        everyWeek: watchedValues.weekly,
        dayOfWeeks: [
          {
            cdDayOfWeek: "MONDAY",
            dayOfWeekName: "월요일",
            select: watchedValues.day?.includes("MONDAY") || false,
          },
          {
            cdDayOfWeek: "TUESDAY",
            dayOfWeekName: "화요일",
            select: watchedValues.day?.includes("TUESDAY") || false,
          },
          {
            cdDayOfWeek: "WEDNESDAY",
            dayOfWeekName: "수요일",
            select: watchedValues.day?.includes("WEDNESDAY") || false,
          },
          {
            cdDayOfWeek: "THURSDAY",
            dayOfWeekName: "목요일",
            select: watchedValues.day?.includes("THURSDAY") || false,
          },
          {
            cdDayOfWeek: "FRIDAY",
            dayOfWeekName: "금요일",
            select: watchedValues.day?.includes("FRIDAY") || false,
          },
          {
            cdDayOfWeek: "SATURDAY",
            dayOfWeekName: "토요일",
            select: watchedValues.day?.includes("SATURDAY") || false,
          },
          {
            cdDayOfWeek: "SUNDAY",
            dayOfWeekName: "일요일",
            select: watchedValues.day?.includes("SUNDAY") || false,
          },
        ],
        paymentCoin: reserveForms.reserveForm.paymentCoin, // 기본값 설정
        additionals: reserveForms.reserveForm.additionals.map(
          (additional: {
            additionalCompanySeq?: number;
            additionalName: string;
            paymentCoin: number;
          }) => ({
            ...additional,
            active: true, // 기본값 설정
            select:
              watchedValues.services?.includes(
                additional.additionalCompanySeq?.toString() || "",
              ) || false,
          }),
        ),
        pets:
          petList?.map((pet: PetDataType) => ({
            petSeq: pet.petSeq,
            petName: pet.petName,
            select: pet.petSeq.toString() === selectedPetSeq,
          })) || [],
        memo: null,
        ...(watchedValues.weekly && { everyWeek: watchedValues.weekly }),
      },
    };

    console.log("코인 계산 API 호출:", requestData);
    const result = calculateCoin(requestData);
    console.log(result);
  };

  // 조건에 따라 코인 계산 API 호출
  useEffect(() => {
    // 1. 등원일을 날짜를 2개다 선택했을 때
    // 2. 매주등원스위치를 누르고 요일을 선택했을 때
    // 3. 매주등원스위치를 false로 했을 때
    // 4. 부가서비스를 선택했을 때

    // const hasBothDates = watchedValues.startDate && watchedValues.endDate;
    const hasPetSelected = selectedPetSeq;

    if (watchedValues.startDate && hasPetSelected && reserveForms) {
      callCalculateCoin();
    }
  }, [
    watchedValues.startDate,
    watchedValues.endDate,
    watchedValues.weekly,
    watchedValues.day,
    watchedValues.services,
    reserveForms,
  ]);

  // petList가 변경될 때 첫 번째 반려동물로 초기화
  // (선택 유지하고 싶으면 이 부분은 생략)
  // useEffect(() => {
  //   if (petList && petList.length > 0) setSelectedPetSeq(petList[0].petSeq.toString());
  // }, [petList]);
  const handleDateClick = (isNext: boolean) => {
    if (isNext) {
      setIsStart(true);
    } else {
      setIsStart(false);
    }
    clickModal();
    // 달력 모달 열기 로직
    // alert("여기에 달력 모달을 띄우세요!");
  };

  const handleDaySelect = (isStart: boolean, day: Date | null) => {
    if (!day) return;

    // const formattedDate = formatDate(day);

    if (isStart) {
      setValue("startDate", day, { shouldValidate: true });
      setStartDate(day);
      // setDate(formattedDate);
    } else {
      setValue("endDate", day, { shouldValidate: true });
      setEndDate(day);
      // setDate(formattedDate);
    }
  };

  // 결제 프로세스 시작
  const handlePaymentProcess = () => {
    if (!calculateCoinData?.data?.paymentCoinTotal) {
      console.error("결제 금액이 없습니다.");
      return;
    }

    // const paymentAmount = calculateCoinData.data.paymentCoinTotal;

    // createTossPreOrder(
    //   { amount: paymentAmount, isRecurringYn: "N" },
    //   {
    //     onSuccess: (response: any) => {
    //       console.log("토스페이먼츠 Pre Order 성공:", response);
    //       setPaymentOrderData(response.data);
    //       setShowPaymentScreen(true);
    //     },
    //     onError: (error: any) => {
    //       console.error("토스페이먼츠 Pre Order 실패:", error);
    //       alert("결제 준비에 실패했습니다. 다시 시도해주세요.");
    //     },
    //   }
    // );
  };

  // 결제 요청 처리
  // const handlePaymentRequest = async () => {
  //   if (!widgetsRef.current || !paymentOrderData) {
  //     alert("결제 시스템이 준비되지 않았습니다.");
  //     return;
  //   }

  //   try {
  //     const paymentResult = await widgetsRef.current.requestPayment({
  //       orderId: paymentOrderData.orderId,
  //       orderName: `유치원 예약 - ${storeName}`,
  //       customerName: paymentOrderData.customerName,
  //       customerEmail: paymentOrderData.customerEmail,
  //       successUrl: `${window.location.origin}/customer/layout/payment/success?reservationSeq=${reservationSeq}`,
  //       failUrl: `${window.location.origin}/customer/layout/payment/fail?reservationSeq=${reservationSeq}`,
  //     });

  //     console.log("결제 요청 성공:", paymentResult);

  //     // 결제 성공 시 updateTempReserve 호출
  //     if (reservationSeq) {
  //       updateTempReserve({
  //         reservationSeq: reservationSeq,
  //         contractCancel: false,
  //       });
  //       console.log("결제 성공 - 임시 예약 상태 업데이트 완료");
  //     }
  //   } catch (error: any) {
  //     console.error("결제 요청 실패:", error);

  //     if (error.code) {
  //       switch (error.code) {
  //         case "PAY_PROCESS_CANCELED":
  //           alert("결제가 취소되었습니다.");
  //           break;
  //         case "PAY_PROCESS_ABORTED":
  //           alert("결제가 중단되었습니다.");
  //           break;
  //         default:
  //           alert(error.message || "결제에 실패했습니다.");
  //       }
  //       if (reservationSeq) {
  //         updateTempReserve({
  //           reservationSeq: reservationSeq,
  //           contractCancel: true,
  //         });
  //         console.log("결제 성공 - 임시 예약 상태 업데이트 완료");
  //       }
  //     } else {
  //       alert("결제에 실패했습니다.");
  //     }
  //   }
  // };

  // 결제 완료 처리 (URL 파라미터에서 호출) - 현재 미사용
  // const handlePaymentComplete = (paymentKey: string, orderId: string, amount: number) => {
  //   confirmTossOrder(
  //     { paymentKey, orderId, amount },
  //     {
  //       onSuccess: (response) => {
  //         console.log("결제 승인 성공:", response);
  //         if (response.data.success) {
  //           // 결제 완료 후 임시저장 상태 변경
  //           if (reservationSeq) {
  //             updateTempReserve({
  //               reservationSeq,
  //               contractCancel: false,
  //             });
  //           }
  //           setShowPaymentScreen(false);
  //           setShowReservationCompleteDialog(true);
  //         } else {
  //           alert("결제 승인에 실패했습니다.");
  //         }
  //       },
  //       onError: (error) => {
  //         console.error("결제 승인 실패:", error);
  //         alert("결제 승인에 실패했습니다.");
  //       },
  //     }
  //   );
  // };

  // const bindSubmit = (data: ReservationClassState) => {
  //   console.log("예약 데이터:", data);

  //   if (!reserveForms || !selectedPetSeq) {
  //     console.error("필수 데이터가 없습니다.");
  //     return;
  //   }

  //   // gradeConfirm 체크
  //   if (!reserveForms.gradeConfirm) {
  //     console.error("해당 반려견의 체급은 수용이 불가능합니다.");
  //     setShowGradeConfirmDialog(true);
  //     return;
  //   }

  //   // 결제 금액 확인
  //   if (!calculateCoinData?.data?.paymentCoinTotal) {
  //     console.error("결제 금액이 없습니다.");
  //     return;
  //   }

  //   // const paymentAmount = calculateCoinData.data.paymentCoinTotal;

  //   // 예약 생성 요청 데이터 구성
  //   const requestData = {
  //     reservationSeq: null,
  //     cdProductType: cdProductType,
  //     gradeConfirm: reserveForms.gradeConfirm,
  //     paymentCoinTotal: calculateCoinData?.data?.paymentCoinTotal || null,
  //     companySeq: parseInt(storeData.value),
  //     reserveForm: {
  //       productSeq: reserveForms.reserveForm.productSeq,
  //       dtReservStart: data.startDate ? formatDate(data.startDate) : null,
  //       dtReservEnd: data.endDate ? formatDate(data.endDate) : null,
  //       everyWeek: data.weekly,
  //       dayOfWeeks: data.weekly
  //         ? [
  //             {
  //               cdDayOfWeek: "MONDAY",
  //               dayOfWeekName: "월요일",
  //               select: data.day?.includes("MONDAY") || false,
  //             },
  //             {
  //               cdDayOfWeek: "TUESDAY",
  //               dayOfWeekName: "화요일",
  //               select: data.day?.includes("TUESDAY") || false,
  //             },
  //             {
  //               cdDayOfWeek: "WEDNESDAY",
  //               dayOfWeekName: "수요일",
  //               select: data.day?.includes("WEDNESDAY") || false,
  //             },
  //             {
  //               cdDayOfWeek: "THURSDAY",
  //               dayOfWeekName: "목요일",
  //               select: data.day?.includes("THURSDAY") || false,
  //             },
  //             {
  //               cdDayOfWeek: "FRIDAY",
  //               dayOfWeekName: "금요일",
  //               select: data.day?.includes("FRIDAY") || false,
  //             },
  //             {
  //               cdDayOfWeek: "SATURDAY",
  //               dayOfWeekName: "토요일",
  //               select: data.day?.includes("SATURDAY") || false,
  //             },
  //             {
  //               cdDayOfWeek: "SUNDAY",
  //               dayOfWeekName: "일요일",
  //               select: data.day?.includes("SUNDAY") || false,
  //             },
  //           ]
  //         : [],
  //       paymentCoin: reserveForms.reserveForm.paymentCoin,
  //       additionals: reserveForms.reserveForm.additionals.map(
  //         (additional: {
  //           additionalCompanySeq?: number;
  //           additionalName: string;
  //           paymentCoin: number;
  //         }) => ({
  //           ...additional,
  //           active: true,
  //           select:
  //             data.services?.includes(
  //               additional.additionalCompanySeq?.toString() || ""
  //             ) || false,
  //         })
  //       ),
  //       pets:
  //         petList?.map((pet: PetDataType) => ({
  //           petSeq: pet.petSeq,
  //           petName: pet.petName,
  //           select: pet.petSeq.toString() === selectedPetSeq,
  //         })) || [],
  //       memo: data.content || null,
  //       ...(data.weekly && { everyWeek: data.weekly }),
  //     },
  //   };

  //   console.log("예약 생성 API 호출:", requestData);

  //   createReserve(requestData as any, {
  //     onSuccess: (response) => {
  //       console.log("예약 생성 응답:", response);
  //       if (response.statusCode === 200) {
  //         // responseCode 확인
  //         if (
  //           response.data?.responseCode === "KINDERGARTEN_RESERVE_REQUESTED"
  //         ) {
  //           // 예약 성공 시 update-temp API 호출
  //           // if (response.data?.reservationSeq) {
  //           //   updateTempReserve({
  //           //     reservationSeq: response.data.reservationSeq,
  //           //     contractCancel: false,
  //           //   });
  //           // }
  //           // setShowReservationCompleteDialog(true);
  //           setReservationSeq(response.data?.reservationSeq || null);
  //           handlePaymentProcess();
  //         } else if (response.data?.responseCode === "INVALID_CONTRACT") {
  //           // 계약이 필요한 경우
  //           setReservationSeq(response.data?.reservationSeq || null);
  //           setContractMessage(response.message || "계약이 필요합니다.");
  //           setShowContractDialog(true);
  //         } else {
  //           // 정상 성공인 경우
  //           alert("예약이 성공적으로 완료되었습니다.");
  //           // history.push("/reservation/success");
  //         }
  //       }
  //     },
  //     onError: (error: unknown) => {
  //       console.error("예약 생성 실패:", error);
  //       alert("예약 생성에 실패했습니다. 다시 시도해주세요.");
  //     },
  //   });

  //   // 토스페이먼츠 pre-order API 호출
  //   // createTossPreOrder(
  //   //   {
  //   //     amount: paymentAmount,
  //   //     isRecurringYn: "N",
  //   //   },
  //   //   {
  //   //     onSuccess: (response) => {
  //   //       console.log("토스페이먼츠 Pre Order 성공:", response);
  //   //       if (response.statusCode === 200) {
  //   //         setPaymentOrderData(response.data);
  //   //         setShowPaymentScreen(true); // 결제 화면 표시
  //   //       }
  //   //     },
  //   //     onError: (error) => {
  //   //       console.error("토스페이먼츠 Pre Order 실패:", error);
  //   //       alert("결제 준비에 실패했습니다. 다시 시도해주세요.");
  //   //     },
  //   //   }
  //   // );
  // };

  // 결제 팝업 닫기 함수
  const handleClosePaymentPopup = async () => {
    try {
      // 위젯 정리
      if (paymentMethodWidgetRef.current) {
        await paymentMethodWidgetRef.current.destroy();
        paymentMethodWidgetRef.current = null;
      }
      if (agreementWidgetRef.current) {
        await agreementWidgetRef.current.destroy();
        agreementWidgetRef.current = null;
      }
      widgetsRef.current = null;
    } catch (error) {
      console.error("위젯 정리 중 오류:", error);
    }

    // 결제 취소 시 updateTempReserve 호출
    if (reservationSeq) {
      updateTempReserve({
        reservationSeq,
        contractCancel: true,
      });
    }

    setShowPaymentScreen(false);
  };

  // 결제 팝업 렌더링 함수
  const renderPaymentPopup = () => {
    if (!showPaymentScreen) return null;

    return (
      <div
        className="flex fixed inset-0 z-50 justify-center items-center bg-black bg-opacity-50"
        onClick={(e) => {
          // 모달 외부 클릭 시 닫히지 않도록 이벤트 전파 방지
          e.stopPropagation();
        }}
        style={{
          touchAction: "manipulation",
          WebkitTapHighlightColor: "transparent",
        }}
      >
        <div
          className="relative w-full max-w-md mx-4 bg-white rounded-lg shadow-xl max-h-[90vh] overflow-y-auto sm:max-w-lg md:max-w-xl"
          onClick={(e) => {
            // 모달 내부 클릭 시 이벤트 전파 방지
            e.stopPropagation();
          }}
          style={{
            transform: "translateZ(0)", // GPU 가속 활성화
            WebkitTransform: "translateZ(0)",
            backfaceVisibility: "hidden",
            WebkitBackfaceVisibility: "hidden",
          }}
        >
          {/* 팝업 헤더 */}
          <div className="flex sticky top-0 z-10 justify-between items-center p-4 bg-white rounded-t-lg border-b border-gray-200">
            <h2 className="text-lg font-semibold">결제</h2>
            <button
              onClick={handleClosePaymentPopup}
              className="relative p-2 text-gray-400 transition-colors hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-opacity-50"
              style={{ touchAction: "manipulation" }}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* 팝업 내용 */}
          <div className="p-4">
            {/* 결제 정보 */}
            <div className="p-4 mb-4 bg-gray-50 rounded-lg">
              <h3 className="mb-3 text-lg font-semibold text-center">
                결제 정보
              </h3>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">주문번호</span>
                  <span className="text-sm font-medium">
                    {paymentOrderData?.orderId}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">결제금액</span>
                  <span className="font-medium text-orange-400">
                    {paymentOrderData?.payAmount?.toLocaleString()}원
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">상품명</span>
                  <span className="text-sm font-medium">
                    유치원 예약 - {storeName}
                  </span>
                </div>
              </div>
            </div>

            {/* 토스페이먼츠 결제 위젯 */}
            <div className="p-4 mb-4 bg-white rounded-lg border border-gray-200">
              <div className="flex justify-between items-center mb-3">
                <h3 className="text-lg font-semibold">결제 수단 선택</h3>
                <button
                  onClick={() => {
                    // 위젯 다시 렌더링 (통합 방식)
                    if (paymentOrderData) {
                      console.log(
                        "🔄 새로고침 버튼 클릭 - 위젯 다시 렌더링 시작",
                      );

                      const reRenderWidgets = async () => {
                        try {
                          // 기존 위젯 제거
                          if (paymentMethodWidgetRef.current) {
                            await paymentMethodWidgetRef.current.destroy();
                            paymentMethodWidgetRef.current = null;
                          }
                          if (agreementWidgetRef.current) {
                            await agreementWidgetRef.current.destroy();
                            agreementWidgetRef.current = null;
                          }

                          // SDK 재초기화
                          const clientKey = paymentOrderData.widgetClientKey;
                          const redirectUrl =
                            import.meta.env.VITE_TOSS_REDIRECT_URL ||
                            "https://app.mungtoday.com/api/payment/toss/brandpay/auth";

                          const toss = await loadTossPayments(
                            clientKey,
                            redirectUrl,
                          );
                          tossPaymentsRef.current = toss;

                          // DOM 요소 대기
                          await new Promise((resolve) =>
                            setTimeout(resolve, 200),
                          );

                          // 위젯 인스턴스 생성
                          widgetsRef.current = tossPaymentsRef.current.widgets({
                            customerKey: paymentOrderData.customerKey,
                            brandpay: {
                              redirectUrl: redirectUrl,
                            },
                          });

                          // 결제 금액 설정
                          await widgetsRef.current.setAmount({
                            value: paymentOrderData.payAmount,
                            currency: "KRW",
                          });

                          // 결제 수단 UI 렌더링
                          const paymentMethodWidget =
                            await widgetsRef.current.renderPaymentMethods({
                              selector: "#payment-methods",
                              variantKey: "DEFAULT",
                            });

                          // 약관 UI 렌더링
                          const agreementWidget =
                            await widgetsRef.current.renderAgreement({
                              selector: "#agreement",
                            });

                          // 위젯 인스턴스 저장
                          paymentMethodWidgetRef.current = paymentMethodWidget;
                          agreementWidgetRef.current = agreementWidget;

                          console.log("✅ 위젯 다시 렌더링 완료");
                        } catch (error) {
                          console.error("❌ 위젯 다시 렌더링 실패:", error);
                        }
                      };
                      reRenderWidgets();
                    }
                  }}
                  className="relative px-3 py-1 text-xs text-gray-600 bg-gray-100 rounded transition-colors hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50"
                  style={{ touchAction: "manipulation" }}
                >
                  새로고침
                </button>
              </div>
              <div id="payment-methods" className="mb-4"></div>
            </div>

            <div className="p-4 mb-4 bg-white rounded-lg border border-gray-200">
              <h3 className="mb-3 text-lg font-semibold">이용약관</h3>
              <div id="agreement" className="mb-4"></div>
            </div>

            {/* 결제 버튼 */}
            {/* <div className="space-y-3">
              <button
                className="relative px-4 py-3 w-full text-base font-medium text-white bg-orange-400 rounded-lg transition-colors hover:bg-orange-500 disabled:bg-gray-300 disabled:cursor-not-allowed sm:px-6 sm:py-4 sm:text-lg focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-opacity-50"
                onClick={handlePaymentRequest}
                disabled={isCreatingPreOrder}
                style={{ touchAction: "manipulation" }}
              >
                {isCreatingPreOrder ? "결제 중..." : "결제하기"}
              </button>
              <button
                className="relative px-4 py-2 w-full text-sm font-medium text-gray-600 rounded-lg border border-gray-300 transition-colors hover:bg-gray-50 sm:px-6 sm:py-3 sm:text-base focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50"
                onClick={handleClosePaymentPopup}
                style={{ touchAction: "manipulation" }}
              >
                취소
              </button>
            </div> */}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <form className="my-5">
        <div className="my-5">
          <Controller
            name="animal"
            control={control}
            render={({ field }) => (
              <ValidateSelectBoxImg
                label="반려동물 선택"
                required={true}
                max={1}
                value={field.value ? [field.value] : []}
                options={
                  petList
                    ? petList.map((item: PetDataType) => ({
                        label: item.petName,
                        value: item.petSeq.toString(),
                        imgSrc: item.fileUrl,
                      }))
                    : []
                }
                onChange={(val: string | string[]) => {
                  const selectedValue = Array.isArray(val) ? val[0] : val;
                  field.onChange(selectedValue);
                  setSelectedPetSeq(selectedValue);
                }}
              />
            )}
          />
        </div>
        <div className="">
          <div className="text-[14px] text-[#999] min-w-[30px] px-1 mb-2">
            * 매주 등원 선택 시 기간, 요일을 지정하셔야 합니다. *
          </div>
          <div className="flex gap-2 items-center mb-4">
            <label className="block pt-2 mb-2 text-sm font-medium">
              일정 선택 <span className="text-orange-400">*</span>
            </label>
            {/* 토글 스위치 */}
            <Controller
              name="weekly"
              control={control}
              render={({ field }) => (
                <ToggleSwitch checked={field.value} onChange={field.onChange} />
              )}
            />
          </div>
          <div className="flex gap-1 items-start">
            {/* 왼쪽: 등원일 */}
            <div className="pt-2 min-w-[37px] text-gray-400 text-[13px]">
              등원일
            </div>
            {/* 오른쪽: 날짜 입력 2개 + "까지" + 토글 */}
            <div className="flex flex-col gap-2">
              {/* 첫 번째 줄: 첫 번째 날짜 */}
              <div className="flex gap-2 items-center">
                <div className="relative">
                  <DateButton
                    value={formatDate(startDate)}
                    onClick={() => handleDateClick(true)}
                  />
                </div>
              </div>
              {/* 두 번째 줄: 두 번째 날짜 + "까지" + 토글 */}
              {watch("weekly") && (
                <div className="flex gap-2 items-center">
                  <div className="relative">
                    <DateButton
                      value={formatDate(endDate)}
                      onClick={() => handleDateClick(false)}
                    />
                  </div>
                  <span className="text-[13px] text-gray-400 min-w-[30px] px-1">
                    까지
                  </span>
                </div>
              )}
            </div>
          </div>
          <div className="mt-4">
            {watch("weekly") && (
              <Controller
                name="day"
                control={control}
                render={({ field }) => (
                  <ValidateControllerSelect
                    value={field.value ? field.value.split(",") : []}
                    onChange={(value) => {
                      field.onChange(value.join(","));
                    }}
                    label="등원요일"
                    required={true}
                    // max={1}
                    col={7}
                    errorMessage={errors?.day?.message}
                    options={[
                      { label: "월", value: "MONDAY" },
                      { label: "화", value: "TUESDAY" },
                      { label: "수", value: "WEDNESDAY" },
                      { label: "목", value: "THURSDAY" },
                      { label: "금", value: "FRIDAY" },
                      { label: "토", value: "SATURDAY" },
                      { label: "일", value: "SUNDAY" },
                    ]}
                  />
                )}
              />
            )}
          </div>

          <div className="mt-4">
            <Controller
              name="services"
              control={control}
              render={({ field }) => (
                <ValidateServiceCard
                  {...field}
                  label="부가서비스 선택"
                  options={
                    reserveForms
                      ? reserveForms.reserveForm.additionals
                          .filter(
                            (item: {
                              additionalCompanySeq?: number;
                              additionalName: string;
                              paymentCoin: number;
                              active?: boolean;
                            }) => item.active === true,
                          )
                          .map(
                            (item: {
                              additionalCompanySeq?: number;
                              additionalName: string;
                              paymentCoin: number;
                            }) => ({
                              id: item.additionalCompanySeq?.toString() || "",
                              title: item.additionalName,
                              desc: item.additionalName,
                              price: item.paymentCoin.toString(),
                            }),
                          )
                      : []
                  }
                />
              )}
            />
          </div>
        </div>
      </form>
      <Divider className="mt-auto" line />
      <div className="flex justify-between my-2">
        <div className="pt-1 mr-1 font-bold text-center text-gray-400 text-m">
          합계
        </div>
        <div className="mr-1 text-xl font-bold text-gray-400">
          {calculateCoinData?.data?.paymentCoinTotal
            ? calculateCoinData?.data?.paymentCoinTotal
            : 0}{" "}
          원
        </div>
      </div>
      <Divider className="mt-auto" line />
      <div className="flex justify-between pt-5 pb-3 text-[#999] text-[13px] leading-[16.9px]">
        예약정보는 예약일 1일 전까지만 수정 및 취소 할 수 있습니다. 예약 당일
        서비스 미 이용 시에도 이용권은 자동으로 소진됩니다.예약 확정은
        위탁사업자 확인 후 이루어집니다.
      </div>
      <div className="flex justify-end my-5 mr-2">
        <Controller
          name="agree"
          control={control}
          rules={{ required: "확인 및 동의가 필요합니다." }}
          render={({ field }) => (
            <ValidateCheckbox
              defaultChecked={field.value}
              onChange={() => field.onChange(!field.value)}
              // errorMessage={errors?.agree?.message}
              title="확인 및 동의"
            />
          )}
        />
      </div>
      {/* <div className="w-full px-5 pb-6 bg-[#F5F5F5] pt-10 grid grid-cols-1 gap-5">
        <Button
          className="w-full bg-[#F5F5F5]"
          style={{ pointerEvents: "auto" }}
          onClick={handleSubmit(bindSubmit)}
          disabled={!isValid || isCreatingPreOrder}
        >
          <div className="py-3 mx-auto w-full text-base font-semibold text-center text-white bg-orange-400 rounded-full">
            {isCreatingPreOrder ? "예약 중..." : "예약 하기"}
          </div>
        </Button>
      </div> */}

      {/* 달력 모달 */}
      <MessageModal
        isOpen={isOpenModal}
        onRequestClose={closeModal}
        className="pt-0 pb-6 mx-auto w-full max-w-sm bg-white rounded-2xl border-2 border-gray-200 shadow-lg outline-none"
        overlayClassName="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
        shouldCloseOnOverlayClick={false}
      >
        <CalendarComponent
          disabled={false}
          dayOnClick={(day) => {
            handleDaySelect(isStart, day);
          }}
          selectedDay={isStart ? startDate : endDate}
          disablePast={true} // startDate 선택 시 오늘 이후만 선택 가능
          minDate={
            isStart ? undefined : startDate ? addDays(startDate, 1) : undefined
          } // endDate 선택 시 startDate 다음날부터 선택 가능
          readOnlyDates={isStart ? [] : startDate ? [startDate] : []} // endDate 선택 시 startDate를 읽기 전용으로 표시
          schedules={{}}
          disabledDates={disabledDates}
          handleSelectDate={handleMonthNavigate}
        />
        <div className="flex gap-3 mt-2">
          <button
            className="flex-1 py-2 font-semibold text-gray-700 bg-gray-200 rounded-full border border-gray-300"
            onClick={closeModal}
          >
            취소
          </button>
          <button
            className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
            onClick={closeModal}
          >
            확인
          </button>
        </div>
      </MessageModal>
      {/* 달력 모달 */}
      {/* 예약 폼 데이터 확인용 디버깅 */}
      {/* {isFormsLoading && <div>예약 폼 로딩중...</div>}
      {reserveForms && (
        <pre style={{ background: '#f5f5f5', padding: 10, margin: 10 }}>{JSON.stringify(reserveForms, null, 2)}</pre>
      )} */}

      {/* 계약 관련 다이얼로그 */}
      <Dialog
        visible={showContractDialog}
        onClose={() => {
          setShowContractDialog(false);
          // onClose 이벤트 시 updateTempReserve 호출
          if (reservationSeq) {
            updateTempReserve({
              reservationSeq,
              contractCancel: true,
            });
          }
        }}
      >
        <div className="p-4">
          <p className="mb-4 text-center">{contractMessage}</p>
          <div className="flex gap-2">
            <button
              className="flex-1 py-2 font-semibold text-gray-700 bg-gray-200 rounded-full border border-gray-300"
              onClick={() => {
                setShowContractDialog(false);
                // 취소 버튼 클릭 시 updateTempReserve 호출
                if (reservationSeq) {
                  updateTempReserve({
                    reservationSeq,
                    contractCancel: true,
                  });
                }
              }}
            >
              취소
            </button>
            <button
              className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full"
              onClick={() => {
                const petSeqNum = petList?.find(
                  (pet) => pet.petSeq.toString() === selectedPetSeq,
                )?.petSeq;
                const companySeqNum = parseInt(storeData.value);
                if (!petSeqNum || !companySeqNum) return;
                // 서명 대상 계약 확보: 대기 계약 우선, 없으면 자동발송 생성
                ensureContractMutation.mutate(
                  { companySeq: companySeqNum, petSeq: petSeqNum },
                  {
                    onSuccess: (requestSeq) => {
                      setShowContractDialog(false);
                      if (requestSeq) {
                        setEnsuredRequestSeq(requestSeq);
                        setShowContractModal(true);
                      } else {
                        // 계약 불필요 → 결제 프로세스로 진행
                        handlePaymentProcess();
                      }
                    },
                    onError: () => {
                      alert(
                        "계약서를 불러오지 못했어요. 잠시 후 다시 시도해 주세요.",
                      );
                    },
                  },
                );
              }}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>

      {/* 계약 모달 */}
      <ContractModal
        visible={showContractModal}
        onClose={() => {
          setShowContractModal(false);
          setEnsuredRequestSeq(null);
        }}
        onConfirm={() => {
          // 서명 완료 후 결제 프로세스로 이동
          setShowContractModal(false);
          setEnsuredRequestSeq(null);
          handlePaymentProcess();
        }}
        selectedPet={petList?.find(
          (pet) => pet.petSeq.toString() === selectedPetSeq,
        )}
        reservationSeq={reservationSeq || undefined}
        companySeq={parseInt(storeData.value)}
        requestSeq={ensuredRequestSeq ?? undefined}
        // userSeq={1} // TODO: 실제 사용자 정보에서 가져오기
      />

      {/* 체급 확인 다이얼로그 */}
      <Dialog
        visible={showGradeConfirmDialog}
        onClose={() => setShowGradeConfirmDialog(false)}
      >
        <div className="p-6 text-center">
          <h3 className="mb-4 text-lg font-bold">체급 수용 불가</h3>
          <p className="mb-6 text-sm text-gray-600">
            해당 반려견의 체급은 수용이 불가능합니다.
          </p>
          <div className="flex justify-center">
            <button
              className="px-8 py-3 font-semibold text-white bg-orange-400 rounded-lg"
              onClick={() => setShowGradeConfirmDialog(false)}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>

      {/* 코인 부족 다이얼로그 */}
      <Dialog
        visible={showCoinShortageDialog}
        onClose={() => setShowCoinShortageDialog(false)}
      >
        <div className="p-6 text-center">
          <h3 className="mb-4 text-lg font-bold">멍코인이 모자라요</h3>
          <p className="mb-6 text-sm text-gray-600">
            멍코인 구매 페이지로 이동합니다.
          </p>
          <div className="flex gap-3">
            <button
              className="flex-1 py-2 font-semibold text-gray-700 bg-white rounded-lg border border-gray-300"
              onClick={() => setShowCoinShortageDialog(false)}
            >
              취소
            </button>
            <button
              className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-lg"
              onClick={() => {
                setShowCoinShortageDialog(false);
                history.push("/customer/layout/user-buy-coin");
              }}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>

      {/* 예약 완료 다이얼로그 */}
      <Dialog
        visible={showReservationCompleteDialog}
        onClose={() => setShowReservationCompleteDialog(false)}
      >
        <div className="p-6 text-center">
          <h3 className="mb-4 text-lg font-bold">예약 신청 완료</h3>
          <div className="p-3 mb-4 bg-gray-100 rounded-lg">
            <span className="font-bold text-black">
              {startDate && endDate
                ? `${startDate
                    .toLocaleDateString("ko-KR", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                    .replace(/\. /g, ".")} ~ ${endDate
                    .toLocaleDateString("ko-KR", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                    .replace(/\. /g, ".")}`
                : new Date()
                    .toLocaleDateString("ko-KR", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                    .replace(/\. /g, ".")}
            </span>
          </div>
          <p className="mb-6 text-sm text-gray-600">
            수업예약이 접수되었습니다.
          </p>
          <div className="flex justify-center">
            <button
              className="px-8 py-3 font-semibold text-white bg-orange-400 rounded-lg"
              onClick={() => {
                setShowReservationCompleteDialog(false);
                history.push("/customer/layout/home");
              }}
            >
              확인
            </button>
          </div>
        </div>
      </Dialog>

      {/* 결제 팝업 */}
      {renderPaymentPopup()}
    </>
  );
};
export default ReservationClass;
